




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Parser } from "json2csv";

@Component({})
export default class extends Vue {
    public headers = [
        { text: "Product", value: "product_name" },
        { text: "Size", value: "product_size" },
        { text: "Category", value: "category_name" },
        { text: "Quantitiy", value: "quantity" },
        { text: "Total Price", value: "total_price" },
        { text: "Total Discount", value: "total_discount" }
    ];

    public fromDate: any = null;
    public toDate: any = null;

    public models: any[] = [];

    public async search() {
        try {
            const result = await app.reportService.getProductsSold(
                this.fromDate,
                this.toDate
            );
            this.models = result;
        } catch (e) {
            console.log(e);
        }
    }

    public sizeName(size: number): string {
        switch (size) {
            case 1:
                return "Regular";
            case 2:
                return "Medium";
            case 3:
                return "Large";
        }
        return "";
    }

    public download(filename: any, data: any) {
        const element = document.createElement("a");
        element.style.display = "none";
        element.setAttribute("href", "data:text/plain," + data);
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    public exportToExcel() {
        const data = this.models.map(e => {
            return {
                ID: e.product_id,
                Product: e.product_name,
                Size: this.sizeName(e.product_size),
                Category: e.category_name,
                Quantity: e.quantity,
                TotalPrice: e.total_price,
                TotalDiscount: e.total_discount
            };
        });

        const fields = [
            "ID",
            "Product",
            "Size",
            "Category",
            "Quantity",
            "TotalPrice",
            "TotalDiscount"
        ];

        const perser = new Parser({ fields });
        const csv = perser.parse(data);
        this.download("Report.csv", csv);
    }
}
